import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import { formatDate } from '@/utils/format/date';

import { inverterValues } from './inverter-values';

const options = {
  chart: {
    type: 'column',
    backgroundColor: '#f9f9f9',
  },
  title: {
    text: 'Daily Energy Throughput (Charge/Discharge)',
  },
  credits: { enabled: false },
  xAxis: {
    categories: inverterValues.map(({ date }) => formatDate(date)),
    title: {
      text: 'Date',
    },
    labels: {
      rotation: -45,
      style: {
        fontSize: '10px',
      },
    },
  },
  yAxis: {
    min: -250,
    max: 250,
    title: {
      text: 'Energy [kWh]',
    },
    tickInterval: 50,
  },
  legend: {
    layout: 'vertical',
    align: 'right',
    verticalAlign: 'top',
    floating: true,
    borderWidth: 1,
    backgroundColor: '#FFFFFFCC',
    shadow: true,
  },
  series: [
    {
      type: 'column',
      name: 'Charge',
      data: inverterValues.map(({ charge }) => charge),
      color: 'var(--color-primary-300)',
    },
    {
      type: 'column',
      name: 'Discharge',
      data: inverterValues.map(({ discharge }) => discharge),
      color: 'var(--color-primary-900)',
    },
  ],
  plotOptions: {
    column: {
      grouping: true,
      stacking: 'normal',
      groupPadding: 0,

      dataLabels: {
        enabled: false,
      },
    },
  },
  tooltip: {
    shared: true,
    valueSuffix: ' kWh',
  },
} satisfies Highcharts.Options;

export function WhiteLabelChargeDischarge() {
  return (
    <div className="relative flex flex-col gap-6 overflow-hidden rounded-lg bg-white px-4 py-8 shadow">
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        className="w-full"
      />
    </div>
  );
}
